import React from 'react';

const AppLoadingAlt = () => {
    return <main className="appIsLoading">
        <div className="altLoadingSection animated zoomIn">
            <i className="ion-md-heart-empty animated zoomOut delay-1s" />
        </div>
    </main>;
};

export default AppLoadingAlt;
